import 'css/src/components/public-pages/careers/CareersOverview';

import React from 'react';

import { Urls } from 'js/src/client';
import VideoPlayer from 'js/src/components/common/custom-player/VideoPlayer';
import JumboCta from 'js/src/components/common/JumboCta';
import Lumen5Icon from 'js/src/components/common/Lumen5Icon';
import { BUTTON_SIZES, PrimaryButton } from 'js/src/components/common/ui/Button';

const CareersOverview = React.memo(function CareersOverview() {
    return (
        <div className="careers-overview">
            <div className="section section-1">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-7 col-sm-12">
                            <h5 className="text-uppercase">CAREERS</h5>
                            <div className="d-flex flex-column my-l5-16">
                                <h4>
                                    At Lumen5, we&apos;re not just a company; we&apos;re a community
                                    of visionaries committed to revolutionizing the video creation
                                    industry.
                                </h4>
                                <br />
                                <h5>
                                    Our mission is clear — to enable creators to become
                                    storytellers, building community and driving demand.
                                </h5>
                                <br />
                            </div>
                            <PrimaryButton
                                href={Urls.CAREER_LISTINGS}
                                size={BUTTON_SIZES.LG}
                                text="View careers"
                            />
                        </div>
                    </div>
                </div>
                <div className="top-fun-image">
                    <img
                        className="so-fun pe-none"
                        src="https://storage.googleapis.com/lumen5-site-images/careers2-min.png"
                    />
                </div>
            </div>
            <div className="section section-2">
                <div className="container">
                    <div className="row pb-l5-48">
                        <div className="col-sm-12">
                            <VideoPlayer
                                src="https://storage.googleapis.com/lumen5-site-images/lumen5-careersTrLHGY.mp4"
                                poster="https://storage.googleapis.com/lumen5-site-images/lumen5-careers-poster.png"
                            />
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="row">
                            <div className="col-sm-12">
                                <br />
                                <br />
                                <h3 className="text-center mb-l5-48">Who we are</h3>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-5">
                                <img
                                    className="w-100"
                                    src="https://storage.googleapis.com/lumen5-site-images/website-assets/career-impact.png"
                                />
                            </div>
                            <div className="col-sm-6 offset-sm-1">
                                <span className="font-l5">
                                    At Lumen5, we believe that video is the most powerful tool for
                                    storytelling, but not everyone has the skills or resources
                                    required to produce professional quality videos. Lumen5 was
                                    created to solve this problem.
                                    <br />
                                    <br />
                                    Launched in 2017, our mission is to make video marketing
                                    accessible to <strong>everyone</strong>.
                                    <br />
                                    <br />
                                    Our commitment to building bridges through the compelling
                                    language of video drives our mission: to empower Creators to
                                    become storytellers, foster community and drive demand.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section section-3">
                <div className="container">
                    <div className="row pt-l5-48 mt-l5-48 mb-l5-48">
                        <div className="col-sm-8 offset-sm-2 align-items-center">
                            <h3 className="text-center">How we work</h3>
                            <h5 className="text-center">
                                You&apos;ll get to work with a team of whip-smart, caring, and
                                hardworking individuals — the kind of people you&apos;ve wanted to
                                work with your entire life. And at the heart of our journey are our
                                core values that define who we are:
                            </h5>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 align-items-left value-item value-item-purple">
                            <div className="value-item-content">
                                <Lumen5Icon />
                                <div className="value-description">
                                    <h3 className="mt-l5-48">Trust</h3>
                                    <hr className="w-25 ms-l5-0" />
                                    <span className="font-l5 font-l5--small">
                                        Within our team and in our relationships with clients, trust
                                        is the cornerstone of everything we do. It&apos;s the
                                        foundation that allows us to innovate, collaborate, and
                                        create transformative solutions.
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 align-items-left value-item value-item-red">
                            <div className="value-item-content">
                                <Lumen5Icon fillColor="#B32A5E" />
                                <div className="value-description">
                                    <h3 className="mt-l5-48">Innovation</h3>
                                    <hr className="w-25 ms-l5-0" />
                                    <span className="font-l5 font-l5--small">
                                        We thrive on creativity and experimentation, always pushing
                                        the boundaries at the forefront of both art and science. At
                                        Lumen5, innovation isn&apos;t just a buzzword; it&apos;s a
                                        way of life. We merge the worlds of video and content with
                                        cutting-edge technology and AI, shaping the future of
                                        storytelling.
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 align-items-left value-item value-item-green">
                            <div className="value-item-content">
                                <Lumen5Icon fillColor="#177C4F" />
                                <div className="value-description">
                                    <h3 className="mt-l5-48">Community</h3>
                                    <hr className="w-25 ms-l5-0" />
                                    <span className="font-l5 font-l5--small">
                                        Our strength lies in our supportive community, fostering
                                        relationships that drive value. Whether it&apos;s supporting
                                        each other within the team or extending a hand to our
                                        clients, community is more than just a word for us —
                                        it&apos;s a commitment.
                                        <br />
                                        <br />
                                        Beyond our immediate circle, we link arms with wider social
                                        initiatives through volunteering and donation matching,
                                        embodying corporate social responsibility.
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-8 offset-sm-2 align-items-center">
                            <br />
                            <br />
                            <h5 className="text-center">
                                Trust, innovation, and community aren&apos;t just words on paper;
                                they&apos;re our guiding principles that shape our culture. When you
                                work at Lumen5, you become an integral part of a values-driven
                                organization.
                            </h5>
                        </div>
                    </div>
                    <div className="row pt-l5-48 mt-l5-48 mb-l5-48">
                        <div className="col-sm-8 offset-sm-2 align-items-center">
                            <h3 className="text-center">Why work for Lumen5</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 align-items-left value-item value-item-blue">
                            <div className="value-item-content">
                                <Lumen5Icon fillColor="#005A7E" />
                                <div className="value-description">
                                    <h3 className="mt-l5-48">Impact</h3>
                                    <hr className="w-25 ms-l5-0" />
                                    <span className="font-l5 font-l5--small">
                                        <strong>Uncharted territories</strong>
                                        <br />
                                        <br />
                                        Our product reaches millions of people around the world.
                                        You&apos;ll be a part of something genuinely impactful and
                                        exciting.
                                        <br />
                                        <br />
                                        Blending creativity and AI, your work will contribute to
                                        transforming the way people create and consume video content
                                        globally.
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 align-items-left value-item value-item-yellow">
                            <div className="value-item-content">
                                <Lumen5Icon fillColor="#944C00" />
                                <div className="value-description">
                                    <h3 className="mt-l5-48">Growth</h3>
                                    <hr className="w-25 ms-l5-0" />
                                    <span className="font-l5 font-l5--small">
                                        <strong>Learn & develop</strong>
                                        <br />
                                        <br />
                                        We don&apos;t toot our own horn often, but we will say that
                                        our team is built of experts. Learn directly from your peers
                                        in cross department settings or invest in yourself. Either
                                        way, we&apos;re here to support through personal growth and
                                        development benefits.
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 align-items-left value-item value-item-orange">
                            <div className="value-item-content">
                                <Lumen5Icon fillColor="#931125" />
                                <div className="value-description">
                                    <h3 className="mt-l5-48">Collaboration</h3>
                                    <hr className="w-25 ms-l5-0" />
                                    <span className="font-l5 font-l5--small">
                                        <strong>Small team, big influence</strong>
                                        <br />
                                        <br />
                                        It&apos;s the relationships and bonds we form that make our
                                        workdays exciting and meaningful. Join a community that
                                        values collaboration, diversity, and inclusion. At Lumen5,
                                        your ideas will be heard, and your contributions will be
                                        celebrated. We believe in the power of teamwork to drive
                                        meaningful change.
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section section-4">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <h3 className="text-center mb-l5-48">Compensation Philosophy</h3>
                        </div>
                    </div>
                    <div className="row mt-l5-48">
                        <div className="col-sm-6">
                            <span className="font-l5">
                                We reward employees for contributing in ways that ignite growth and
                                accelerate performance while aligning with our values and achieving
                                defined objectives.
                                <br />
                                <br />
                                We value employees by providing opportunities for real impact,
                                meaningful progress and quality connections.
                                <br />
                                <br />
                                We communicate <strong>openly</strong> about the process and design
                                of our rewards & compensation programs, plans, and initiatives to
                                ensure everyone understands how their contributions are recognized.
                                <br />
                                <br />
                                We create <strong>career paths</strong> for employees to
                                continuously improve in their craft and challenge them to stretch
                                even further.
                            </span>
                        </div>
                        <div className="col-sm-5 offset-sm-1">
                            <img
                                className="w-100"
                                src="https://storage.googleapis.com/lumen5-site-images/website-assets/career-progress.png"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="section section-5">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <h3 className="text-center">You may have seen us...</h3>
                            <h5 className="text-center">
                                Recognized for excellence in growth and culture
                            </h5>
                            <img
                                className="w-75 margin-center"
                                src="https://storage.googleapis.com/lumen5-site-images/website-assets/awards-min.png"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="section section-6">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3">
                            <h3 className="mb-l5-48">Join a company that&apos;s got your back</h3>
                        </div>
                        <div className="col-md-9">
                            <div className="row">
                                <div className="col-sm-6 mb-l5-48">
                                    <span className="material-symbols-outlined icon-l5 perk-icon orange-icon">
                                        beach_access
                                    </span>
                                    <h5 className="fw-bold my-l5-16">Rest and Recharge</h5>
                                    <span className="font-l5">
                                        4 weeks vacation + unlimited personal days
                                    </span>
                                </div>
                                <div className="col-sm-6 mb-l5-48">
                                    <span className="material-symbols-outlined icon-l5 perk-icon green-icon">
                                        health_and_safety
                                    </span>
                                    <h5 className="fw-bold my-l5-16">Health = Happiness</h5>
                                    <span className="font-l5">
                                        Full medical, dental, and generous paramedical
                                    </span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6 mb-l5-48 pt-l5-16">
                                    <span className="material-symbols-outlined icon-l5 perk-icon red-icon">
                                        show_chart
                                    </span>
                                    <h5 className="fw-bold my-l5-16">Stock Options</h5>
                                    <span className="font-l5">
                                        We offer employees equity in the company
                                    </span>
                                </div>
                                <div className="col-sm-6 mb-l5-48 pt-l5-16">
                                    <span className="material-symbols-outlined icon-l5 perk-icon pink-icon">
                                        spa
                                    </span>
                                    <h5 className="fw-bold my-l5-16">Growth & Development</h5>
                                    <span className="font-l5">
                                        $2000/year for learning & development
                                    </span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6 mb-l5-48 pt-l5-16">
                                    <span className="material-symbols-outlined icon-l5 perk-icon pink-icon">
                                        sports_esports
                                    </span>
                                    <h5 className="fw-bold my-l5-16">Live Your Life</h5>
                                    <span className="font-l5">
                                        $120/month Lifestyle Spending Account
                                    </span>
                                </div>
                                <div className="col-sm-6 mb-l5-48 pt-l5-16">
                                    <span className="material-symbols-outlined icon-l5 perk-icon blurple-icon">
                                        child_care
                                    </span>
                                    <h5 className="fw-bold my-l5-16">Family First</h5>
                                    <span className="font-l5">Generous parental leave top-ups</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6 mb-l5-48 pt-l5-16">
                                    <span className="material-symbols-outlined icon-l5 perk-icon orange-icon">
                                        smartphone
                                    </span>
                                    <h5 className="fw-bold my-l5-16">Ring Ring</h5>
                                    <span className="font-l5">
                                        We&apos;ll cover your monthly phone bill
                                    </span>
                                </div>
                                <div className="col-sm-6 mb-l5-48 pt-l5-16">
                                    <span className="material-symbols-outlined icon-l5 perk-icon blurple-icon">
                                        audiotrack
                                    </span>
                                    <h5 className="fw-bold my-l5-16">Jam to Tunes</h5>
                                    <span className="font-l5">
                                        Spotify or Apple Music, whatever you jam out to
                                    </span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6 mb-l5-48 pt-l5-16">
                                    <span className="material-symbols-outlined icon-l5 perk-icon grey-icon">
                                        schedule
                                    </span>
                                    <h5 className="fw-bold my-l5-16">Flexible Work</h5>
                                    <span className="font-l5">
                                        Set your own schedule, do your best work
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section section-4">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <h3 className="text-center mb-l5-48">You belong here</h3>
                        </div>
                    </div>
                    <div className="row mt-l5-48">
                        <div className="col-sm-6">
                            <span className="font-l5">
                                Joining Lumen5 means being part of a passionate group that&apos;s
                                dedicated to redefining the future of video creation with AI, while
                                constantly learning and growing in a collaborative environment. It
                                means contributing to a culture of trust, where your ideas matter
                                and your voice is heard.
                                <br />
                                <br />
                                Together, we&apos;re not just building a company; we&apos;re shaping
                                an industry and creating connections through video storytelling.
                                <br />
                                <br />
                                If you&apos;re ready to make an impact and be part of something
                                extraordinary, Lumen5 is where your journey begins. Welcome to the
                                AI video revolution.
                            </span>
                        </div>
                        <div className="col-sm-5 offset-sm-1">
                            <img
                                className="w-100"
                                src="https://storage.googleapis.com/lumen5-site-images/website-assets/career-connection.png"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="mb-l5-48">
                <JumboCta
                    header="Let's create waves together"
                    linkUrl={Urls.CAREER_LISTINGS}
                    linkText="View careers"
                />
            </div>
        </div>
    );
});

export default CareersOverview;
